import { DataProvider } from 'react-admin'
import { VerifierSchemeDataDto } from '../../dto/verifier-scheme-data.dto'

const fakeVerifierSchemeData: VerifierSchemeDataDto[] = []

const provider = {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getList: (resource, params) =>
    Promise.resolve({
      data: fakeVerifierSchemeData,
      total: fakeVerifierSchemeData.length,
    }),
} as DataProvider

export default provider
